import http from '../common/api';
import {ApiSettings} from "application";
import StorageService from "infrastructure/common/storage";
import {Constant} from "presentation/new-report/common/data";

const payRequest = async (data) => {
  const referral_code = StorageService.getItem(Constant.ls_referral_code);

  const payload = {
    "id_solicitud": data.requestId,
    "plan": data.planSelected.type,
    "amount": data.planSelected.price,
    'payment_type': data.paymentType,
    'rut_billing': data.billInfo.rut,
    'social_reason': data.billInfo.businessType,
    'economic_activity': data.billInfo.economicActivity,
    'address': data.billInfo.address,
    "preferencia_ppu": data.licenseNumber,
    'referral': referral_code
  }

  return await http.post(ApiSettings.payRequest, payload);
}

export default payRequest;
